import axios from 'axios'
import { getAuthToken, removeAuthToken, signOut } from '@/utils/auth'

const baseUrl = process.env.VUE_APP_API_BASE_URL || 'https://staging-eagle-api.beusable.net'
// const baseUrl = 'http://10.0.1.36:3000'

function isPlainObject (value: any) {
  return Object.prototype.toString.call(value) === '[object Object]'
}

function isApiUrl (url: any) {
  if (url.charAt(0) === '/') {
    return true
  }
  return url.indexOf(baseUrl) === 0
}

function normalizeRequest (data: any) {
  if (isPlainObject(data)) {
    for (const key of Object.keys(data)) {
      if (typeof data[key] === 'string') {
        data[key] = data[key].trim()
      } else {
        normalizeRequest(data[key])
      }
    }
  } else if (Array.isArray(data)) {
    for (let i = 0; i < data.length; i++) {
      if (typeof data[i] === 'string') {
        data[i] = data[i].trim()
      } else {
        normalizeRequest(data[i])
      }
    }
  }

  return data
}

const httpClient = axios.create({
  baseURL: baseUrl,
  headers: {
    'Cache-Control': 'no-cache',
  }
})

httpClient.interceptors.request.use(function (config) {
  if (isApiUrl(config.url)) {
    if (config.data) {
      config.data = normalizeRequest(config.data);
    }

    if (config.method === 'get') {
      config.params = config.params || {};
      config.params.t = new Date().getTime();
    }

    if (config.url?.includes('image_upload')) {
      config.headers['Content-Type'] = 'multipart/form-data'
    }

    const authToken = getAuthToken()

    if (authToken) {
      try {
        const token = JSON.parse(authToken);
        if (!token.accessToken) {
          removeAuthToken();
        } else {
          config.headers.Authorization = `Bearer ${token.accessToken}`;
          // console.log('token', config.headers.Authorization);
        }
      } catch (e) {
        console.error('Invalid auth token format:', e);
        removeAuthToken();
      }
    }
  }
  return config
}, function (error) {
  console.error('Request error:', error);
  return Promise.reject(error);
})

httpClient.interceptors.response.use(function (response) {
  if (isApiUrl(response.config.url) && !response.data.success) {
    const message = response.data.message || 'RESPONSE_FAILED'
    return Promise.reject(new Error(message));
  } else {
    return response
  }
}, function (error) {
  if (error.response) {
    if (!error.response.config.skipError) {
      if (error.response.status === 401) {
        signOut(true);
      }
    }
  } else {
    console.error('Unexpected error:', error.message);
  }
  return Promise.reject(error);
})
export default httpClient
